<header class="app-header" [class.sidebar-open]="isSidebarOpen" [class.no-sidebar]="!hasSidebar" *ngIf="config">

  <div class="header-inner">
    <div class="header-layout">

      <!-- LEFT / CENTER -->
      <div class="header-center">
        <span *ngIf="config.showBack" class="back-icon" (click)="goBack()">
          <i class="pi pi-arrow-left"></i>
        </span>

        <div class="title-wrap">
          <div class="breadcrumbs" *ngIf="config.breadcrumbs?.length">
            <ng-container *ngFor="let crumb of config.breadcrumbs; let last = last">

              <span class="crumb" [class.clickable]="crumb.route" (click)="crumb.route && navigate(crumb.route)">
                {{ crumb.label }}
              </span>

              <span *ngIf="!last" class="separator">
                <img src="assets/icons/chevron-right.svg">
              </span>

            </ng-container>
          </div>
          <!-- TITLE + STATUS ROW -->
          <div class="title-row">
            <h2 class="form-label">{{ displayTitle }}</h2>

            <span *ngIf="config.status as status" class="status-pill" [ngClass]="status.variant">
              {{ status.label }}
            </span>
          </div>

          <!-- OLD SUBTITLE SUPPORT -->
          <p *ngIf="config.subtitle && !config.subtitleDetails?.length" class="form-label subtitle">
            {{ truncatedSubtitle }}
          </p>

          <!-- NEW RICH SUBTITLE -->
          <div *ngIf="config.subtitleDetails?.length" class="header-details">
            <div class="detail-item" *ngFor="let item of config.subtitleDetails; let last = last">

              <span class="detail-icon" *ngIf="item.icon">
                <img [src]="item.icon" />
              </span>

              <span class="detail-label">
                {{ item.label }}
              </span>

              <span class="detail-value" [pTooltip]="item.value" tooltipPosition="top">
                {{ item.value }}
              </span>

              <span *ngIf="!last" class="detail-separator"></span>

            </div>
          </div>

          <div class="header-meta" *ngIf="config.details?.length">
            <div class="meta-item" *ngFor="let item of config.details">
              <i *ngIf="item.icon" [class]="item.icon" aria-hidden="true"></i>
              <span [class.fw-bold]="item.bold">
                {{ item.label }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- RIGHT -->
      <div class="header-right">

        <div class="support-icon" pTooltip="Support" tooltipPosition="left" appendTo="body" (click)="openSupport()">
          <i class="pi pi-question-circle"></i>
        </div>

        <lib-notification [settingsTitle]="'Notification'" [toastDisplayDurationMs]=10000></lib-notification>

        <ng-container *ngIf="config">
          <div *ngFor="let action of config.actions || []" class="btn-wrapper" [pTooltip]="action.tooltip"
            tooltipPosition="bottom" [tooltipDisabled]="!action.tooltip" [escape]="false"
            tooltipStyleClass="custom-tooltip" appendTo="body">

            <button class="btn" [ngClass]="action.variant" [disabled]="action.disabled" (click)="onActionClick(action)">

              <span *ngIf="action.icon" class="btn-icon">
                <img [src]="action.icon" alt="" />
              </span>

              {{ action.label }}
            </button>

          </div>
        </ng-container>

      </div>
    </div>
  </div>
</header>